import React, { useState, useEffect, Fragment } from "react";
import Chip from "@material-ui/core/Chip";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(1),
    marginLeft: "0px",
  },
}));

export default function StatusChip({ status }) {
  const classes = useStyles();
  const [value, setValue] = useState(null);

  useEffect(() => {
    switch (status) {
      case 2:
        setValue({
          label: "Suspended",
          backgroundColor: "grey",
          color: "white",
        });
        break;
      case 1:
        setValue({
          label: "Active",
          backgroundColor: "green",
          color: "white",
        });
        break;

      default:
        break;
    }
  }, [status]);

  return (
    <Fragment>
      {value && (
        <Chip
          size="small"
          variant="outlined"
          label={value.label}
          className={classes.chip}
          style={{ backgroundColor: value.backgroundColor, color: value.color }}
        />
      )}
    </Fragment>
  );
}
